import type { FrontifyImageContent } from '@/contentful';

export const MAX_IMAGE_WIDTH = 1920;

// On the Contentful Frontify object, the field `preview_url` has a URL param for width
// we can replace it with the px value we want for the image width
// imgUrl: pass in the `preview_url`
// width: retrieve the image url with the given width
export function setImgWidth(
  imgUrl: string | undefined,
  width: number,
  format?: string
): string {
  if (!imgUrl) {
    return '';
  }

  try {
    // Strip URL params if present
    const imgUrlObject = new URL(imgUrl);
    const modifiedImgUrlObject: URL = new URL(
      `${imgUrlObject.origin}${imgUrlObject.pathname}`
    );

    // Add width to image URL
    modifiedImgUrlObject.searchParams.append('width', width.toString());

    // Add webp format parameter
    modifiedImgUrlObject.searchParams.append('format', format || 'webp');

    return modifiedImgUrlObject.toString();
  } catch {
    // Handle invalid URL passed in
    console.log('Attempting to use invalid Frontify URL');
    return '';
  }
}

// Returns url string to be used in background images
export function getFrontifyBackgroundImageUrl(
  image: FrontifyImageContent | string,
  width: number
): string {
  // get the integer number device pixel ratio (1, 2, 3, etc.), in case it's 0, then default to 1
  const devicePixelRatio =
    typeof window !== 'undefined'
      ? Math.round(window.devicePixelRatio) > 0
        ? Math.round(window.devicePixelRatio)
        : 1
      : 3;
  const imageString = typeof image === 'string' ? image : image?.preview_url;
  const imgUrl = setImgWidth(imageString, Math.round(width * devicePixelRatio));

  return imgUrl.startsWith('url(') ? imgUrl : `url('${imgUrl}')`;
}

export function setSrcSetImg(
  imgUrl?: string,
  width?: number
): string | undefined {
  if (imgUrl && width) {
    return `${setImgWidth(imgUrl, width)} 1x, ${setImgWidth(
      imgUrl,
      2 * width
    )} 2x, ${setImgWidth(imgUrl, 3 * width)} 3x`;
  } else {
    return undefined;
  }
}

export const isFrontifyAsset = (
  param: unknown
): param is FrontifyImageContent => {
  if (typeof param === 'object' && param !== null) {
    return 'preview_url' in param;
  }
  return false;
};
